/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqItemPagedData } from '../../models/faq-item-paged-data';

export interface GetFaqs$Params {
  PageNumber?: number;
  PageSize?: number;
  'X-Region'?: any;
}

export function getFaqs(http: HttpClient, rootUrl: string, params?: GetFaqs$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqItemPagedData>> {
  const rb = new RequestBuilder(rootUrl, getFaqs.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.header('X-Region', params['X-Region'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqItemPagedData>;
    })
  );
}

getFaqs.PATH = '/faq';
